import { STATUS_FAILURE, STATUS_SUCCESS } from 'Common/constants/commonConstants';
import * as TransferedFilesConstans from './TransferedFilesConstans';
import { produce } from 'immer';
const assign = Object.assign || require('object.assign');

const initialState = {}

export default function D2CTransferedFilesReducer(state = initialState, action){
    switch(action.type){
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isD2CTransferdFilesFetching: false,
                    isD2CTransferdFilesFetchFailed: false,
                    D2CTransferedFileList: [],
                    downloadingFile: false,
                    errorMessage: "",
                    downloadFileFailed: false,
                    hasMore: true,
                    pageSize: 20
                }
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isD2CTransferdFilesFetching : false,
                    isD2CTransferdFilesFetchFailed: true,
                    errorMessage: action.payload.errorMessage,
                    D2CTransferedFileList : [],
                    downloadStatus: 0,
                    downloadSpeed: 0,
                    estimatedTime: 0
                };
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isD2CTransferdFilesFetching : false,
                    isD2CTransferdFilesFetchFailed: false,
                    D2CTransferedFileList : action.payload.newState,
                    hasMore: action.payload.newState.length == state[action.payload.instanceId].pageSize ? true : false
                };
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isD2CTransferdFilesFetching : true,
                    isD2CTransferdFilesFetchFailed: false,
                    D2CTransferedFileList : [],
                    hasMore: false,
                    downloadStatus: 0,
                    downloadSpeed: 0,
                    errorMessage: "", 
                    estimatedTime: 0
                };
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_GET_PAGE_SUCCESS: {
            let hasMore = true;
            if(action.payload.newState.length < state[action.payload.instanceId].pageSize){
                hasMore = false;
            }
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    D2CTransferedFileList : [...state[action.payload.instanceId].D2CTransferedFileList, ...action.payload.newState],
                    hasMore: hasMore,
                    downloadStatus: 0,
                    downloadSpeed: 0,
                    estimatedTime: 0
                };
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_FILES_FROM_SERVICE_BUS: {
            const newState = produce(state, (draft) => {
                const retrievedFile = draft[action.payload.instanceId].D2CTransferedFileList.find(x => x.topicListener?.subscription === action.payload.newState.RequestID);
                if (retrievedFile) {
                    if (action.payload.newState.IsSuccessful){
                        retrievedFile.cloudFilePath = action.payload.newState.BlobPath;
                        retrievedFile.status = STATUS_SUCCESS;
                    } else {
                        retrievedFile.status = STATUS_FAILURE;
                        retrievedFile.failureMessage= action.payload.newState.FailureDetails;
                    }
                    retrievedFile.topicListener = undefined;
                }
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.UPDATE_FILE_LIST_ON_RETRIEVE_FILES: {
            let newFilesSelected = [];
            action.payload.newState.map((elem) =>{
                let obj = {
                    topicListener: elem.topicListener,
                    cloudFilePath: elem.cloudFilePath,
                    status: elem.status,
                    instFilePath: elem.instFilePath,
                    type: elem.type,
                    date: elem.date,
                }
                newFilesSelected.push(obj);
            });
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    D2CTransferedFileList : [...newFilesSelected, ...state[action.payload.instanceId].D2CTransferedFileList]
                };
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_DOWNLOAD_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    downloadFileFailed: true,
                    downloadingFile: false,
                    downloadStatus: 0,
                    downloadSpeed: 0,
                    estimatedTime: 0
                };
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_DOWNLOAD_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    downloadFileFailed: false,
                    downloadingFile: true
                };
            });
            return assign({}, state, newState);
        }
        case TransferedFilesConstans.D2C_TRANSFERED_FILES_DOWNLOAD_RESET: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    downloadFileFailed: false,
                    downloadingFile: false
                };
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}